import {forwardRef} from 'react';
import {Box, TextField, Typography} from '@mui/material';
import DatePicker from 'react-datepicker';
import {DateTime} from 'luxon';
import 'react-datepicker/dist/react-datepicker.css';

const parseDate = (isoDate) => {
    if (!isoDate) {
        return null;
    }
    const parsed = DateTime.fromISO(isoDate);
    return parsed.isValid ? parsed.toJSDate() : null;
};

const toIsoDate = (date) => (date ? DateTime.fromJSDate(date).toISODate() : '');

const DateRangeInput = forwardRef(function DateRangeInput({value, onClick}, ref) {
    return (
        <TextField
            ref={ref}
            size="small"
            fullWidth
            value={value || ''}
            placeholder="MM/DD/YYYY – MM/DD/YYYY"
            onClick={onClick}
            slotProps={{input: {readOnly: true}}}
        />
    );
});

export const DateRangePicker = ({label, start, end, onChange}) => {
    const startDate = parseDate(start);
    const endDate = parseDate(end);

    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
            <Typography variant="h7" sx={{whiteSpace: 'nowrap', width: '120px'}}>{label}:</Typography>
            <Box sx={{flex: 1, minWidth: 0}}>
                <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(dates) => {
                        const [newStart, newEnd] = dates;
                        onChange(toIsoDate(newStart), toIsoDate(newEnd));
                    }}
                    dateFormat="MM/dd/yyyy"
                    customInput={<DateRangeInput/>}
                    monthsShown={1}
                    showPopperArrow={false}
                    popperClassName="pmx-date-range-popper"
                    wrapperClassName="pmx-date-range-wrapper"
                />
            </Box>
        </Box>
    );
};
